/* App Components */

// Common bundle
import maSidenavLayout from '@/views/sidenavLayout'
import maLogout from '@/views/logout'
import maSearch from '@/views/search'

// Warranty
import maWarrantyLayout from '@/views/warrantyLayout'
import maWarrantyView from '@/views/warrantyLayout/views/warrantyView'
import maAgentWarrantyView from '@/views/warrantyLayout/views/agentWarrantyView'

// GAG admin
import maAdminGAGLayout from '@/views/adminGAGLayout'
import maAdminGAGParameters from '@/views/adminGAGLayout/views/parameters'
import maAdminGAGRepMat from '@/views/adminGAGLayout/views/repMat'
import maAdminGAGZipCode from '@/views/adminGAGLayout/views/zipCode'
import maAdminGAGAjustAge from '@/views/adminGAGLayout/views/ajustage'
import maAdminGAGUserLimits from '@/views/adminGAGLayout/views/userLimits'
import maAdminGAGSalaries from '@/views/adminGAGLayout/views/salaries'

// Damages admin
import maAdminLayout from '@/views/adminLayout'
import maAdminDamagesParameters from '@/views/adminLayout/views/parameters'
import maAdminDamagesReparations from '@/views/adminLayout/views/reparations'
import maAdminDamagesCoefficients from '@/views/adminLayout/views/coefficients'
import maAdminDamagesDepreciations from '@/views/adminLayout/views/depreciations'
import maAdminDamagesTransversalscosts from '@/views/adminLayout/views/transversalcosts'

// Users admin
import maAdminUsers from '@/views/adminLayout/views/users'

// Forms admin
import maAdminForms from '@/views/adminLayout/views/forms'

// Charts admin
import maAdminCharts from '@/views/adminLayout/views/charts'

// Tutorials
import maTutorials from '@/views/tutorials'

import extraInfoLayout from '@/views/extraInfoLayout'

// Dashboard admin
import maGAGDashboard from '@/views/dashboard/views/GAG'

const views = {
  maSidenavLayout,
  maWarrantyLayout,
  maWarrantyView,
  maAgentWarrantyView,
  maAdminLayout,
  maAdminGAGLayout,
  maAdminGAGParameters,
  maAdminGAGRepMat,
  maAdminGAGZipCode,
  maAdminGAGAjustAge,
  maAdminGAGUserLimits,
  maAdminGAGSalaries,
  maAdminDamagesParameters,
  maAdminDamagesReparations,
  maAdminDamagesCoefficients,
  maAdminDamagesDepreciations,
  maAdminDamagesTransversalscosts,
  maAdminCharts,
  maLogout,
  maSearch,
  maAdminUsers,
  maAdminForms,
  maTutorials,
  maGAGDashboard,
  extraInfoLayout
}

export default views
